import { useIntl } from 'react-intl';

import { padStart } from '@/utils/timeUtils';

import { useCountDown } from '@/hooks/useCountDown';
import { commonMessages } from '@/messages/common';

import * as S from './CountDown.styles';

interface CountDownProps {
  countdownToDatetime: string | number | Date;
  textColor?: string | null;
}
export const CountDown = ({
  countdownToDatetime,
  textColor,
}: CountDownProps) => {
  const { formatMessage } = useIntl();
  const formatCountdownToDatetime = new Date(countdownToDatetime).getTime();
  const now = Date.now();
  const milliseconds = isNaN(formatCountdownToDatetime)
    ? now - 1000
    : formatCountdownToDatetime;

  const expirationTimestamp = Math.floor(milliseconds / 1000);
  const timeToGo = useCountDown(expirationTimestamp);

  if (!countdownToDatetime || isNaN(formatCountdownToDatetime)) {
    return null;
  }

  let { days, hours, minutes, seconds } = timeToGo ?? {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  if (days === -1) {
    //When the time set by the user is met, leave the countdown to 00.00.00.00
    days = 0;
    hours = 0;
    minutes = 0;
    seconds = 0;
  }

  if (milliseconds < now || !!timeToGo) {
    return (
      <S.Wrapper
        $textColor={textColor}
        aria-label={`Countdown: ${days} days : ${hours} hours : ${minutes} minutes : ${seconds} seconds`}
      >
        <S.NumberWrapper>
          <S.Number suppressHydrationWarning={true}>{padStart(days)}</S.Number>
          <S.Label>{formatMessage(commonMessages.days)}</S.Label>
        </S.NumberWrapper>
        <S.Separator>:</S.Separator>
        <S.NumberWrapper>
          <S.Number suppressHydrationWarning={true}>{padStart(hours)}</S.Number>
          <S.Label>{formatMessage(commonMessages.hours)}</S.Label>
        </S.NumberWrapper>
        <S.Separator>:</S.Separator>
        <S.NumberWrapper>
          <S.Number suppressHydrationWarning={true}>
            {padStart(minutes)}
          </S.Number>
          <S.Label>{formatMessage(commonMessages.minutes)}</S.Label>
        </S.NumberWrapper>
        <S.Separator>:</S.Separator>
        <S.NumberWrapper>
          <S.Number suppressHydrationWarning={true}>
            {padStart(seconds)}
          </S.Number>
          <S.Label>{formatMessage(commonMessages.seconds)}</S.Label>
        </S.NumberWrapper>
      </S.Wrapper>
    );
  }
  return <S.Wrapper></S.Wrapper>;
};
